import { render, staticRenderFns } from "./AppointmentsTable.vue?vue&type=template&id=2dd01404&"
import script from "./AppointmentsTable.vue?vue&type=script&lang=js&"
export * from "./AppointmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports